class Annonce{
    constructor(element) {
        this.element = element;
        this.id = this.element.getAttribute('id');
        this.link = this.element.parentElement;
        this.arrows = this.element.querySelectorAll('.splide__arrow');
        this.media_nb = this.element.querySelector('.media_nb-content');
        this.videos = this.element.querySelectorAll('.player');
        this.key = "";
        this.lockAction = false;
        this.init();
    }
    init(){
        if (this.element.querySelector('.annonce-slider__slider')) {
            new Splide(this.element.querySelector('.annonce-slider__slider'), {
                autoWidth: true,
                autoHeight: true,
                lazyLoad: "nearby",
                pagination: false,
                keyboard: false,
                perPage: 1,
                perMove: 1,	
                drag: false,
            }).mount();	
        }
        this.link.addEventListener('click', (e) => {
            if ((e.target.classList.contains('not_click') || e.target.closest('.not_click'))) {
                e.preventDefault();
            }else{
                window.history.replaceState({}, '', window.location.href.split('#')[0] + '#'+ this.link.getAttribute('id'));
            }
        }); 
        this.videos.forEach(video => {
            this.key = video.getAttribute('data-thumbnails');
            this.new_plyr(video, this.key);      
            video._instance_plyr.on('play', (e) => {
                e.preventDefault();
                if (video._instance_plyr.playing) {
                    this.hide_nb_media();
                }   
            });
            video.addEventListener('mouseenter', (e) => {
                video._instance_plyr.toggleControls(true);
            }); 
        });
        this.arrows.forEach(arrow => {
            arrow.addEventListener('click', (e) => {
                e.preventDefault();
                this.videos.forEach(video => {
                    if (video._instance_plyr.playing) {
                        video._instance_plyr.pause();
                    }
                });
                this.show_nb_media();
            }); 
        });
    }
    new_plyr(video, key){
        video._instance_plyr = new Plyr(video); 
        if (key) {
            video._instance_plyr.poster = key;
        }else{
            video._instance_plyr.poster = "/img/placeholder-event.png";            
        }
    }
    hide_nb_media(){
        this.media_nb.classList.add('hide');
    }
    show_nb_media(){
        this.media_nb.classList.remove('hide');
    }   
}

class Annonces {
    constructor(string) {
        this.tab_inst_annonces = [];
        document.querySelectorAll(string).forEach((element) => {
            this.tab_inst_annonces.push(element._instanceannonces = new Annonce(element));
        });   
    
    }
    setAnnonce_w_thumbnail(element){
        this.tab_inst_annonces.push(element._instanceannonces = new Annonce_w_thumbnails(element));
    }
}
const annonces = new Annonces('.annonce-slider');

class Annonce_w_thumbnails{
    constructor(element) {
        this.element = element;
        this.link = this.element.parentElement;
        this.arrows = this.element.querySelectorAll('.splide__arrow');
        this.media_nb = this.element.querySelector('.media_nb-content');
        this.videos = this.element.querySelectorAll('.player');
        this.tumbnails = this.element.querySelectorAll('.annonce_single__slider__thumbnail__item');
        this.key = "";
        this.init();
    }
    init(){
        console.log('init');
        if (this.element.querySelector('.annonce-slider__slider')) {
            new Splide(this.element.querySelector('.annonce-slider__slider'), {
                autoWidth: true,
                autoHeight: true,
                lazyLoad: "nearby",
                pagination: false,
                keyboard: false,
                perPage: 1,
                perMove: 1,	
                drag: false,
            }).mount();	
        } 
        this.link.addEventListener('click', (e) => {
            if ((e.target.classList.contains('not_click') || e.target.closest('.not_click'))) {
                e.preventDefault();
            }
        }); 
        this.videos.forEach(video => {
            this.key = video.getAttribute('data-thumbnails');
            this.new_plyr(video, this.key);      
            video._instance_plyr.on('play', (e) => {
                e.preventDefault();
                if (video._instance_plyr.playing) {
                    this.hide_nb_media();
                }   
            });
            video.addEventListener('mouseenter', (e) => {
                video._instance_plyr.toggleControls(true);
            }); 
        });
        this.arrows.forEach(arrow => {
            arrow.addEventListener('click', (e) => {
                e.preventDefault();
                this.videos.forEach(video => {
                    if (video._instance_plyr.playing) {
                        video._instance_plyr.pause();
                    }
                });
                this.show_nb_media();
            }); 
        });

        this.tumbnails.forEach(tumbnail => {
            tumbnail.addEventListener('click', (e) => {
                e.preventDefault();
                this.videos.forEach(video => {
                    if (video._instance_plyr.playing) {
                        video._instance_plyr.pause();
                    }
                });
                this.show_nb_media();
            }); 
        });
    }
    new_plyr(video, key){
        video._instance_plyr = new Plyr(video); 
        if (key) {
            video._instance_plyr.poster = key;
        }else{
            video._instance_plyr.poster = "/assets/images/annonce/placeholder/placeholder-video-xs.jpg";            
        }
    }
    hide_nb_media(){
        this.media_nb.classList.add('hide');
    }
    show_nb_media(){
        this.media_nb.classList.remove('hide');
    }
}

if (document.querySelector('#annonce_single-slider #main-slider')) {
    annonces.setAnnonce_w_thumbnail(document.querySelector('#annonce_single-slider'));
}

document.addEventListener( 'DOMContentLoaded', function () {
    var main = new Splide( '#main-slider', {
        autoWidth: true,
		autoHeight: true,
		lazyLoad: "nearby",
		pagination: false,
		type: "loop",
		perPage: 1,
		perMove: 1,
		drag: false,
        keyboard: false,
    });
    
    var thumbnails = new Splide( '#thumbnail-slider', {
        direction:'ttb',
        autoWidth: true,
		heightRatio: 3,
        pagination: false,
        cover: true,
        isNavigation: true,
        arrows: false,
        focus: 'center',
        perPage: 3,
        breakpoints: {
            640: {
                direction:'ltr',
                perPage: 1,
                perMove:1,
		        heightRatio: false,
                focus: false,


            },
      }
    });
  
    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();
});